
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DictionaryCurrencyEntity } from '../types';

@Injectable({
  providedIn: 'root'
})
export class DictionaryCurrencyService {

  constructor(private http: HttpClient) { }

  getAll(): Observable<DictionaryCurrencyEntity[]> {
    return this.http.get<DictionaryCurrencyEntity[]>('/api/dictionary/currency');
  }

  getById(id: number): Observable<DictionaryCurrencyEntity[]> {
    const params = new HttpParams().set('id', id.toString());
    return this.http.get<DictionaryCurrencyEntity[]>('/api/dictionary/currency', { params });
  }

  add(record: DictionaryCurrencyEntity): Observable<void> {
    return this.http.post<void>('/api/dictionary/currency', record);
  }

  delete(record: DictionaryCurrencyEntity): Observable<void> {
    return this.http.delete<void>('/api/dictionary/currency', { body: record });
  }
}


